
const config = {
    API_ENDPOINT: `https://quiet-reaches-89043.herokuapp.com/api`,
    API_KEY: process.env.REACT_APP_API_KEY,
    API_SEARCH: 'https://quiet-reaches-89043.herokuapp.com/api/bars/search'
}

export default config